// 独自JSがある場合はrequire
const initialized = [
    require('./opening/storematch').initialized,
];

import { createAppWrap } from '../../create_app_wrap';
import childPageCommonMixin from './_mixin';

const view = '[data-view^="guide-"]';
const init = () => {
    createAppWrap({
        el: view,
        mixins: [
            childPageCommonMixin,
        ]
    });
};

// 独自JSがinitされていない場合実行
if (document.querySelector(view) && !initialized.filter(Boolean).length) {
    init();
}